import { createActionGroup, emptyProps } from '@ngrx/store';

export const SignUpStateActions = createActionGroup({
  source: 'Sign Up State Actions',
  events: {
    'Sign Up': emptyProps(),
  },
});
